import {
	requestApiDelete,
	requestApiGet,
	requestApiPatch,
	requestApiPost,
} from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { Webhook } from "../entities/Webhook";
import { assert } from "../utils/BacklogUtil";
import type { AddWebhookParams } from "./params/AddWebhookParams";
import type { DeleteWebhookParams } from "./params/DeleteWebhookParams";
import type { GetListOfWebhooksParams } from "./params/GetListOfWebhooksParams";
import type { GetWebhookParams } from "./params/GetWebhookParams";
import type { UpdateWebhookParams } from "./params/UpdateWebhookParams";

/**
 * Get List of Webhooks Webhook一覧の取得
 *
 * Returns list of webhooks.
 */
export function getListOfWebhooks(
	config: BacklogConfig,
	params: GetListOfWebhooksParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Webhook[]>> {
	assert(params);
	return requestApiGet({
		config,
		path: "projects/:projectIdOrKey/webhooks",
		params,
		context,
	});
}

/**
 * Add Webhook Webhookの追加
 *
 * Adds new webhook.
 */
export function addWebhook(
	config: BacklogConfig,
	params: AddWebhookParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Webhook>> {
	assert(params);
	return requestApiPost({
		config,
		path: "projects/:projectIdOrKey/webhooks",
		params,
		context,
	});
}

/**
 * Get Webhook Webhookの取得
 *
 * Returns information about webhook.
 */
export function getWebhook(
	config: BacklogConfig,
	params: GetWebhookParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Webhook>> {
	assert(params);
	return requestApiGet({
		config,
		path: "projects/:projectIdOrKey/webhooks/:webhookId",
		params,
		context,
	});
}

/**
 * Update Webhook Webhookの更新
 *
 * Updates information about webhook.
 */
export function updateWebhook(
	config: BacklogConfig,
	params: UpdateWebhookParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Webhook>> {
	assert(params);
	return requestApiPatch({
		config,
		path: "projects/:projectIdOrKey/webhooks/:webhookId",
		params,
		context,
	});
}

/**
 * Delete Webhook Webhookの削除
 *
 * Deletes webhook.
 */
export function deleteWebhook(
	config: BacklogConfig,
	params: DeleteWebhookParams,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Webhook>> {
	assert(params);
	return requestApiDelete({
		config,
		path: "projects/:projectIdOrKey/webhooks/:webhookId",
		params,
		context,
	});
}
